exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".entity-form .ant-form-item {\n  display: flex; }\n  .entity-form .ant-form-item .ant-form-item-label {\n    width: 100px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/sass-loader/lib/loader.js?{}!./src/pages/Curd/style.scss
// module id = 106
// module chunks = 0